if (!customElements.get('litmus-purchase-options')) {
  customElements.define('litmus-purchase-options', class extends HTMLElement {
    connectedCallback() {
      this.planInput = this.querySelector('[data-litmus-plan-input]');
      this.quantityInput = this.querySelector('[data-litmus-quantity-input]');
      this.controller = new AbortController();
      this.addEventListener('change', (event) => {
        if (!event.target.matches('input[type="radio"]')) return;
        this.sync();
      }, { signal: this.controller.signal });
      this.sync();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    sync() {
      const selected = this.querySelector('input[type="radio"]:checked')?.closest('.litmus-review-offer');
      if (!selected || !this.planInput || !this.quantityInput) return;
      const planId = selected.dataset.planId || '';
      const packs = Number(selected.dataset.packs || 1);
      this.planInput.value = planId;
      this.quantityInput.value = Number.isInteger(packs) && packs > 0 ? String(packs) : '1';
      this.dataset.selectedPlan = planId;
      this.dataset.selectedQuantity = this.quantityInput.value;
      for (const input of [this.planInput, this.quantityInput]) {
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
}
